/**
 * VideoSection section frontend logic
 */
(function videoSectionFrontend($) {
    $(document).on('cms.ready', ready);

    function ready() {
        $(document).on('click', '.sectionVideoSection video', function handleClick(e) {
            let video = this;

            if (video.muted) {
                console.log('Video clicked: Unmuting and restarting');

                video.pause();
                video.muted = false;
                video.currentTime = 0;
                video.controls = true;

                setTimeout(function () {
                    let playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.then(_ => {
                            console.log('Playback started successfully');
                        }).catch(error => {
                            console.error('Playback failed after restart:', error);
                            video.play();
                        });
                    }
                }, 50);
            }
        });

        $('.sectionVideoSection video').each(function () {
            this.muted = true;
            this.autoplay = true;
            this.loop = true;
            this.controls = false;

            let v = this;
            v.play().catch(e => {
                console.warn('Initial autoplay failed (expected if no interaction):', e);
            });
        });
    }
})(jQuery);
